module.exports = __webpack_public_path__ + "img/learnemp.com.d5947a99.png";